<template>
  <input
    type="text"
    alt="decimal-us"
    :class="inputClass"
    :placeholder="placeholder"
    :value="value"
    @input="log"
    @keydown.tab="tab"
    @focus="focus"
  />
</template>

<script>
import $ from 'jquery'
import '../../lib/meiomask/jquery.meio.mask'
export default {
  props: [
    'placeholder',
    'inputClass',
    'tabPress',
    'inputFocus',
    'value',
    'callback'
  ],
  mounted() {
    $('input[type="text"]').each(() => {
      $(this.$el).setMask($(this.$el).attr('alt'))
      $(this.$el).on('test', (e, data) => {
        this.$emit('input', data)
        if (this.callback) this.callback(data)
      })
    })
  },
  methods: {
    tab() {
      if (this.tabPress) this.tabPress()
    },
    log() {
      setTimeout(() => {
        this.$emit('input', $(this.$el).val())
        if (this.callback) this.callback($(this.$el).val())
      }, 500)
    },
    focus(e) {
      if (this.inputFocus) {
        this.inputFocus(e)
      }
    },
    data() {
      return {
        data: ''
      }
    }
  }
}
</script>
